import { Route, Routes } from "react-router-dom";
import React, { useContext, useEffect } from "react";
import { AuthContext, IAuthContext } from "react-oauth2-code-pkce";
import TopNavBar from "src/components/Nav/TopNavBar";
import LoggedOut from "src/views/LoggedOut";
import AuthStore from "src/stores/AuthStore";
import Home from "../views/Home";
import ExternalRedirect from "./ExternalRedirect";

const staticDocsUrl: string = process.env.REACT_APP_STATIC_DOCS || "";


function AppRouter() {
  const { token, error, tokenData, idTokenData }: IAuthContext =
    useContext(AuthContext);

  useEffect(() => {
    //console.log(tokenData);
    AuthStore.mapToken(tokenData, idTokenData);
  }, [token, tokenData, idTokenData]);

  if (error) {
    window.location.reload();
  }

  if (!token) {
    return (
      <>
        <LoggedOut />
      </>
    );
  } else {
    return (
      <>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path={"/about"} element={<ExternalRedirect url={staticDocsUrl + "/about"} />} />
          <Route path={"/faq"} element={<ExternalRedirect url={staticDocsUrl + "/faq"} />} />
          <Route path={"/terms"} element={<ExternalRedirect url={staticDocsUrl + "/terms"} />} />
          <Route path={"/privacy"} element={<ExternalRedirect url={staticDocsUrl + "/privacy"} />} />
        </Routes>
      </>
    );
  }
}

export default AppRouter;
